
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReport_01_Dt_Grid extends Serenity.EntityGrid<MbReport_01_Dt_Row, any> {
        protected getColumnsKey() { return MbReport_01_Dt_Columns.columnsKey; }
        protected getDialogType() { return MbReport_01_Dt_Dialog; }
        protected getIdProperty() { return MbReport_01_Dt_Row.idProperty; }
        protected getInsertPermission() { return MbReport_01_Dt_Row.insertPermission; }
        protected getLocalTextPrefix() { return MbReport_01_Dt_Row.localTextPrefix; }
        protected getService() { return MbReport_01_Dt_Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}